import { render, staticRenderFns } from "./vAgentChat.vue?vue&type=template&id=135c10d6&scoped=true"
import script from "./vAgentChat.vue?vue&type=script&lang=js"
export * from "./vAgentChat.vue?vue&type=script&lang=js"
import style0 from "./vAgentChat.vue?vue&type=style&index=0&id=135c10d6&prod&scoped=true&lang=css"
import style1 from "./vAgentChat.vue?vue&type=style&index=1&id=135c10d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c10d6",
  null
  
)

export default component.exports